const getNext3Months = () => {
  const now = new Date()
  const next3Months = []

  for (let i = 0; i < 3; i++) {
    next3Months.push(new Date(now.getFullYear(), now.getMonth() + i + 1, 1))
  }

  return next3Months
}

export { getNext3Months }
